// update along with app/lib/enums/job_enums.py
const JobRunStatus = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  SUCCESS: 'SUCCESS',
  FAILED: 'FAILED',
};

// react-bootstrap Badge variants, keyed by JobRunStatus
const JOB_RUN_STATUS_VARIANT = {
  [JobRunStatus.PENDING]: 'warning',
  [JobRunStatus.RUNNING]: 'primary',
  [JobRunStatus.SUCCESS]: 'success',
  [JobRunStatus.FAILED]: 'danger',
};

const JOB_RUN_STATUS_VARIANT_DEFAULT = 'secondary';

const getJobRunStatusVariant = status =>
  JOB_RUN_STATUS_VARIANT[status] || JOB_RUN_STATUS_VARIANT_DEFAULT;

export { JobRunStatus, getJobRunStatusVariant };
